export function Search() {
  const modalScope = document.querySelectorAll(".modal-search")

  modalScope.forEach((element) => {
    const modal = element.querySelector(".modal-container.search")

    const btn = element.querySelector(".btn-modal")

    const span = element.getElementsByClassName("btn-close")[0]

    function closeModal() {
      modal.style.maxHeight = "0"
      modal.style.visibility = "hidden"
    }

    document.addEventListener("keyup", (e) => {
      if (modal.style.maxHeight === "100%" && e.key === "Escape") {
        closeModal()
      }
    })

    if (btn) {
      btn.onclick = function block() {
        modal.style.maxHeight = "100%"
        modal.style.visibility = "visible"
      }
    }

    if (span) {
      span.onclick = function close() {
        closeModal()
      }
    }

    window.onclick = function hide(event) {
      if (event.target === modal) {
        closeModal()
      }
    }
  })
}
